import { Controller } from "@hotwired/stimulus"

function numberToCurrency(value) {
  return Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  }).split(".")[0];
}

export default class extends Controller {
  static values = {
    title: String,
    height: Number,
    series: Array, // {name, data}
  };

  connect = async () => {
    const { default: ApexCharts } = await import("apexcharts")
    // A turbo navigation can disconnect us while the import is in flight; don't
    // render onto a detached element (ApexCharts would throw).
    if (!this.element.isConnected) return

    let series = this.seriesValue

    let chart = new ApexCharts(this.element, {
      chart: {
        type: 'line',
        height: this.heightValue,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        }
      },
      grid: {
        borderColor: "#444",
        clipMarkers: false,
        xaxis: {
          lines: {
            show: true

          },
        },
        yaxis: {
          lines: {
            show: true
          },
        },
      },
      title: {
        text: this.titleValue,
        align: 'left',
      },
      series: series,
      theme: {
        mode: 'dark'
      },
      yaxis: {
        min: 0,
        max: 100,
        labels: {
          formatter: function(val, loa) {
            return val + "%"
          },
        },
        opposite: true,
      }
    })

    chart.render()
  }
}
